export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-book-bookmark-094bec16259ea10e4f2eb839f38d9c4c.svg";